/* Bright Home Lights Tier A buy-box configurator.
   Extracted from templates/product.bundle.json's inline custom_liquid block
   so it's cached as a static asset instead of re-downloaded/re-parsed with
   every product page load. Config is read from a JSON script tag rendered
   by the block (data-bhl-buybox-config), since this file can't contain
   Liquid. */
(() => {
  const root = document.querySelector('[data-bhl-upgrade-selector]');
  if (!root) return;

  const configScript = document.querySelector('[data-bhl-buybox-config]');
  let config = null;
  try {
    config = configScript ? JSON.parse(configScript.textContent) : null;
  } catch (e) {
    config = null;
  }

  const hasSystemStep = !!(config && config.hasSystemStep && config.tiers && config.tiers.length);
  const tiersByLength = {};
  if (config && config.tiers) {
    config.tiers.forEach((t) => { tiersByLength[t.length] = t; });
  }

  const options = root.querySelector('[data-bhl-system-options]');
  const systemStep = root.querySelector('[data-bhl-system-step]');
  const lengthStep = root.querySelector('.bhl-step--length');
  const lengthStepNumber = lengthStep?.querySelector('.bhl-step-number');
  const lengthOptions = root.querySelector('[data-bhl-length-options]');
  const lengthLabel = root.querySelector('[data-bhl-length-label]');
  const note = root.querySelector('[data-bhl-system-note]');
  const assurance = root.querySelector('[data-bhl-purchase-assurance]');
  const customColorHelp = root.querySelector('.bhl-custom-color-help');
  const includesPanel = root.querySelector('[data-bhl-includes]');
  const metaEl = root.querySelector('[data-bhl-meta]');
  const skuEl = root.querySelector('[data-bhl-sku]');
  const lengths = ['50FT', '100FT', '150FT', '200FT', '250FT', '300FT', '350FT', '400FT', '450FT'];
  const mobileIncludesQuery = window.matchMedia('(max-width: 749px)');
  const isDIYProduct = /\/products\/permanent-diy-led\/?$/i.test(window.location.pathname);
  const diyCombinedOptionPrefix = 'Voltage and Temperature-';

  if (systemStep) systemStep.hidden = !hasSystemStep;

  function normalizeLength(value) {
    const match = String(value || '').toUpperCase().match(/(50|100|150|200|250|300|350|400|450)\s*FT/);
    return match ? `${match[1]}FT` : '';
  }

  function optionButton(title, price, copy, configuration, selected) {
    return `
      <button class="bhl-upgrade-selector__option" type="button" aria-pressed="${selected}" data-bhl-system-choice="${configuration}">
        <span class="bhl-upgrade-selector__option-title">${title}</span>
        <span class="bhl-upgrade-selector__option-price">${price}</span>
        <span class="bhl-upgrade-selector__option-copy">${copy}</span>
      </button>
    `;
  }

  // Matches both the Complete Bundle's compound "150FT / 12V Standard" values
  // and the DIY product's plain "150FT" values (no tier suffix) - the older
  // /FT\s*\// pattern only matched the compound form, so it silently found
  // zero fields on DIY and Length clicks there never actually selected a
  // variant.
  const LENGTH_VALUE_RE = /^(?:50|100|150|200|250|300|350|400|450)\s*FT\b/i;

  function nativeConfigurationFields() {
    return [...document.querySelectorAll('input[type="radio"], select')].filter((field) => {
      if (field.tagName === 'SELECT') {
        return [...field.options].some((option) => LENGTH_VALUE_RE.test(option.value));
      }
      return LENGTH_VALUE_RE.test(field.value);
    });
  }

  function currentConfiguration() {
    for (const field of nativeConfigurationFields()) {
      if (field.tagName === 'SELECT' && field.value) return field.value;
      if (field.checked) return field.value;
    }
    return '';
  }

  function selectConfiguration(configuration) {
    const fields = nativeConfigurationFields();
    const radio = fields.find((field) => field.tagName === 'INPUT' && field.value === configuration);
    if (radio) {
      radio.click();
      scheduleNativeDecoration();
      return;
    }

    const select = fields.find((field) => field.tagName === 'SELECT' && [...field.options].some((option) => option.value === configuration));
    if (select) {
      select.value = configuration;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      scheduleNativeDecoration();
    }
  }

  function selectVoltage(voltage) {
    if (combinedConfigurationFields().length) {
      return selectCombinedConfiguration(voltage, lineItemTemperature);
    }

    const radio = [...document.querySelectorAll('input[type="radio"][name^="Voltage-"]')]
      .find((field) => field.value === voltage);
    if (!radio || radio.disabled) return false;

    radio.click();
    scheduleNativeDecoration();
    return true;
  }

  function combinedConfigurationFields() {
    if (!isDIYProduct) return [];
    return [...document.querySelectorAll(`input[type="radio"][name^="${diyCombinedOptionPrefix}"]`)];
  }

  function parseCombinedConfiguration(value) {
    const text = String(value || '');
    return {
      voltage: /24V/i.test(text) ? '24V' : /12V/i.test(text) ? '12V' : '',
      temperature: /3000K|Warm White/i.test(text) ? 'Warm White' : /6000K|Daylight/i.test(text) ? 'Daylight' : '',
    };
  }

  function selectedCombinedConfiguration() {
    const checked = combinedConfigurationFields().find((field) => field.checked);
    return parseCombinedConfiguration(checked?.value || '');
  }

  function selectCombinedConfiguration(voltage, temperature) {
    const targetVoltage = String(voltage || '').toUpperCase();
    const targetTemperature = /warm|3000/i.test(String(temperature || '')) ? 'Warm White' : 'Daylight';
    const radio = combinedConfigurationFields().find((field) => {
      const parsed = parseCombinedConfiguration(field.value);
      return parsed.voltage === targetVoltage && parsed.temperature === targetTemperature;
    });
    if (!radio || radio.disabled) return false;
    if (!radio.checked) radio.click();
    scheduleNativeDecoration();
    return true;
  }

  function mountAndHideNativeConfiguration() {
    const fields = nativeConfigurationFields();
    if (!fields.length) return;

    const picker = fields[0].closest('variant-picker');
    const customBlock = root.parentElement;
    if (picker && customBlock && picker.parentNode === customBlock.parentNode) {
      picker.parentNode.insertBefore(customBlock, picker);
    }

    let group = fields[0].parentElement;
    while (group && !fields.every((field) => group.contains(field))) {
      group = group.parentElement;
    }

    if (group && !group.contains(root)) {
      group.hidden = true;
      group.style.setProperty('display', 'none', 'important');
      group.setAttribute('aria-hidden', 'true');
      return;
    }

    fields.forEach((field) => {
      field.hidden = true;
      const label = field.id ? document.querySelector(`label[for="${CSS.escape(field.id)}"]`) : null;
      if (label) label.hidden = true;
    });
  }

  function renderIncludes(configuration) {
    const panel = includesPanel;
    if (!panel || !config) return;
    const length = normalizeLength(configuration) || normalizeLength(lengths.find((l) => tiersByLength[l]) || '');
    const tier = hasSystemStep ? tiersByLength[length] : null;
    if (hasSystemStep && !tier) { panel.hidden = true; return; }

    const n = Math.ceil(parseInt(length, 10) / 100) * 2;
    const is24v = /24V/i.test(String(configuration || ''));
    const items = [];
    if (hasSystemStep) {
      items.push(is24v && config.controller24vSpec ? config.controller24vSpec : tier.controllerSpec);
    }
    if (config.includeAccessoryKit !== false && length) {
      items.push(`(${n}) 5FT and (${n}) 10FT extension cables`);
      items.push(`(${n}) Male/female pigtails and (${n}) Power-T connectors`);
    }
    if (config.trackLine) items.push(config.trackLine);
    if (config.appLine) items.push(config.appLine);

    panel.querySelector('[data-bhl-includes-length]').textContent = `${length} kit`;
    panel.querySelector('[data-bhl-includes-list]').innerHTML = items.filter(Boolean).map((i) => `<li>${i}</li>`).join('');

    const specsList = panel.querySelector('[data-bhl-includes-specs]');
    if (specsList) {
      specsList.innerHTML = (config.specRows || []).map((row) => `<li><b>${row.label}</b><span>${row.value}</span></li>`).join('');
    }

    panel.hidden = false;
    panel.open = true;
  }

  let skuMap = null;
  async function syncSku() {
    // Cached at setup rather than queried here: reorderForAccessibility()
    // relocates bhl-meta (which wraps this element) outside of root to fix
    // Tab order, so a fresh root.querySelector() would stop finding it.
    const el = skuEl;
    if (!el) return;
    if (!skuMap) {
      try {
        const res = await fetch(`${window.location.pathname.split('?')[0]}.js`);
        const data = await res.json();
        skuMap = Object.fromEntries(data.variants.map((v) => [String(v.id), v.sku || '']));
      } catch (e) { return; }
    }
    const input = document.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]');
    const sku = input && skuMap[String(input.value)];
    el.textContent = sku || '';
  }

  function currentVoltage() {
    return document.querySelector('input[type="radio"][name="Voltage-split"]:checked')?.value ||
      document.querySelector('input[type="radio"][name^="Voltage-"]:checked')?.value ||
      selectedCombinedConfiguration().voltage || '';
  }

  let lineItemTemperature = 'Daylight';

  function ensureSplitVoltageSelector() {
    if (!combinedConfigurationFields().length) return null;

    let selector = document.querySelector('[data-bhl-split-voltage]');
    if (selector) return selector;

    selector = document.createElement('fieldset');
    selector.className = 'variant-option variant-option--buttons variant-option--equal-width-buttons bhl-split-voltage';
    selector.dataset.bhlSplitVoltage = '';
    selector.innerHTML = `
      <legend class="bhl-native-step-label">
        <b class="bhl-step-number">01</b>
        Voltage
        <span class="bhl-legend-value" data-bhl-voltage-value></span>
      </legend>
      <label class="variant-option__button-label">
        <input type="radio" name="Voltage-split" value="12V">
        <span class="variant-option__button-label__pill"></span>
        <span class="variant-option__button-label__text">12V</span>
      </label>
      <label class="variant-option__button-label">
        <input type="radio" name="Voltage-split" value="24V">
        <span class="variant-option__button-label__pill"></span>
        <span class="variant-option__button-label__text">24V</span>
      </label>
    `;

    const variantPicker = document.querySelector('.product-details variant-picker');
    if (variantPicker) variantPicker.insertAdjacentElement('beforebegin', selector);
    return selector;
  }

  function ensureLineItemTemperature() {
    if (!isDIYProduct) return null;

    let selector = document.querySelector('[data-bhl-line-temperature]');
    if (selector) return selector;

    // The legacy product stored temperature as a line-item property because
    // Voltage, Length, and Track Color already occupied Shopify's three option
    // slots. The updated product combines voltage + temperature internally,
    // while this control keeps the customer-facing choices separate and clear.
    selector = document.createElement('fieldset');
    selector.className = 'variant-option variant-option--buttons variant-option--equal-width-buttons bhl-line-item-temperature';
    selector.dataset.bhlLineTemperature = '';
    selector.innerHTML = `
      <legend class="bhl-native-step-label">
        <b class="bhl-step-number">04</b>
        Light Temperature
        <span class="bhl-legend-value" data-bhl-temperature-value>${lineItemTemperature}</span>
      </legend>
      <label class="variant-option__button-label">
        <input type="radio" name="Light Temperature-line-item" value="Daylight" ${lineItemTemperature === 'Daylight' ? 'checked' : ''}>
        <span class="variant-option__button-label__pill"></span>
        <span class="variant-option__button-label__text">Daylight</span>
      </label>
      <label class="variant-option__button-label">
        <input type="radio" name="Light Temperature-line-item" value="Warm White" ${lineItemTemperature === 'Warm White' ? 'checked' : ''}>
        <span class="variant-option__button-label__pill"></span>
        <span class="variant-option__button-label__text">Warm White</span>
      </label>
    `;

    const variantPicker = document.querySelector('.product-details variant-picker');
    if (variantPicker) variantPicker.insertAdjacentElement('afterend', selector);
    return selector;
  }

  function syncSplitControlsFromNative() {
    const selected = selectedCombinedConfiguration();
    if (!selected.voltage || !selected.temperature) return;

    lineItemTemperature = selected.temperature;
    const voltageSelector = ensureSplitVoltageSelector();
    const temperatureSelector = ensureLineItemTemperature();
    const voltageInput = voltageSelector?.querySelector(`input[name="Voltage-split"][value="${selected.voltage}"]`);
    const temperatureInput = [...(temperatureSelector?.querySelectorAll('input[name="Light Temperature-line-item"]') || [])]
      .find((field) => field.value === selected.temperature);
    if (voltageInput) voltageInput.checked = true;
    if (temperatureInput) temperatureInput.checked = true;
  }

  function syncLineItemTemperature(applyNativeSelection = true) {
    const selector = ensureLineItemTemperature();
    if (!selector) return;

    const selected = selector.querySelector('input[name="Light Temperature-line-item"]:checked')?.value || lineItemTemperature;
    lineItemTemperature = selected;
    const valueEl = selector.querySelector('[data-bhl-temperature-value]');
    if (valueEl) valueEl.textContent = selected;

    const forms = document.querySelectorAll(
      '.product-details form[action*="/cart/add"], sticky-add-to-cart form[action*="/cart/add"], .sticky-add-to-cart form[action*="/cart/add"]'
    );

    if (combinedConfigurationFields().length) {
      forms.forEach((form) => form.querySelector('input[data-bhl-temperature-property]')?.remove());
      if (applyNativeSelection) selectCombinedConfiguration(currentVoltage(), selected);
      return;
    }

    forms.forEach((form) => {
      let input = form.querySelector('input[data-bhl-temperature-property]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Light Temperature]';
        input.dataset.bhlTemperatureProperty = '';
        form.appendChild(input);
      }
      input.value = selected;
    });
  }

  let pendingLength = '';

  function positionIncludes() {
    const panel = includesPanel;
    if (!panel) return false;

    if (mobileIncludesQuery.matches) {
      const buyButtons = document.querySelector('.product-details .buy-buttons-block');
      if (!buyButtons) return false;
      panel.classList.remove('bhl-includes--gallery');
      if (buyButtons.nextElementSibling !== panel) {
        buyButtons.insertAdjacentElement('afterend', panel);
      }
      return true;
    }

    const gallery = document.querySelector('media-gallery, [data-testid="product-media-gallery"]');
    if (gallery && panel.previousElementSibling !== gallery) {
      panel.classList.add('bhl-includes--gallery');
      gallery.insertAdjacentElement('afterend', panel);
    }
    return Boolean(gallery);
  }

  function render(configuration = currentConfiguration()) {
    const length = normalizeLength(configuration) || '50FT';

    lengthOptions.innerHTML = lengths.map((value) => `
      ${value === '450FT'
        ? '<a class="bhl-upgrade-selector__length" href="/pages/contact" title="Request a quote for 450FT or more">450FT+<br>Quote</a>'
        : `<button
            class="bhl-upgrade-selector__length"
            type="button"
            aria-pressed="${value === length}"
            data-bhl-length="${value}"
            ${value === '400FT' ? 'title="400FT requires 24V"' : ''}
          >${value}</button>`
      }
    `).join('');

    if (!hasSystemStep) {
      renderIncludes(configuration);
      return;
    }

    lengthLabel.textContent = `${length} selected`;
    const tier = tiersByLength[length];

    if (!tier) {
      options.innerHTML = '<p class="bhl-upgrade-selector__prompt">This configuration is not available for online purchase yet.</p>';
      note.textContent = 'Contact Bright Home Lights for a custom configuration.';
      renderIncludes(configuration);
      return;
    }

    if (tier.systemType === 'included') {
      options.innerHTML = optionButton(tier.standardLabel, 'Included', tier.standardCopy, tier.standardValue, true);
      note.textContent = tier.note || '';
      renderIncludes(configuration);
      return;
    }

    options.innerHTML =
      optionButton(tier.standardLabel, 'Included', tier.standardCopy, tier.standardValue, configuration === tier.standardValue) +
      optionButton(tier.upgradeLabel, `+${tier.upgradePrice}`, tier.upgradeCopy, tier.upgradeValue, configuration === tier.upgradeValue);
    note.textContent = tier.note || '';
    renderIncludes(configuration);
  }

  // Delegated on document rather than root: reorderForAccessibility() (below)
  // physically relocates .bhl-step--length and .bhl-step--system outside of
  // root to fix Tab/reading order, so a root-scoped listener would stop
  // seeing clicks on those buttons once they've moved.
  document.addEventListener('click', (event) => {
    const lengthButton = event.target.closest('[data-bhl-length]');
    if (lengthButton) {
      const length = lengthButton.dataset.bhlLength;

      // The lights-only product offers 400FT in 24V only. If a shopper
      // chooses 400FT while 12V is active, move to 24V first and wait for
      // Horizon's variant-picker update to finish before selecting 400FT.
      // This prevents a temporary impossible 12V / 400FT combination from
      // removing Add to cart or leaving stale price/SKU content behind.
      if (!hasSystemStep && length === '400FT' && /12V/i.test(currentVoltage())) {
        pendingLength = length;
        if (!selectVoltage('24V')) pendingLength = '';
        return;
      }

      const tier = tiersByLength[length];
      const configuration = tier ? tier.standardValue : length;
      if (hasSystemStep && configuration) selectConfiguration(configuration);
      else if (!hasSystemStep) selectConfiguration(length);
      window.setTimeout(() => render(configuration), 0);
      return;
    }

    const choice = event.target.closest('[data-bhl-system-choice]');
    if (!choice) return;
    selectConfiguration(choice.dataset.bhlSystemChoice);
    window.setTimeout(() => render(choice.dataset.bhlSystemChoice), 0);
  });

  document.addEventListener('change', (event) => {
    if (LENGTH_VALUE_RE.test(event.target.value || '')) {
      window.setTimeout(() => render(event.target.value), 0);
    }

    const fieldName = String(event.target.name || '');
    if (fieldName === 'Voltage-split') selectVoltage(event.target.value);
    if (
      LENGTH_VALUE_RE.test(event.target.value || '') ||
      fieldName.startsWith('Voltage-') ||
      fieldName.startsWith(diyCombinedOptionPrefix) ||
      fieldName.startsWith('Light Temperature-') ||
      fieldName.startsWith('Track Color-')
    ) {
      if (fieldName === 'Light Temperature-line-item') syncLineItemTemperature();
      scheduleNativeDecoration();
      window.setTimeout(syncSku, 60);
    }
  });

  function scheduleNativeDecoration() {
    window.setTimeout(decorateNativeOptions, 0);
    window.setTimeout(decorateNativeOptions, 180);
    window.setTimeout(decorateNativeOptions, 500);
  }

  function addStepNumber(fieldset, number) {
    const legend = fieldset?.querySelector('legend');
    if (!legend || legend.querySelector('.bhl-step-number')) return;
    const marker = document.createElement('b');
    marker.className = 'bhl-step-number';
    marker.textContent = number;
    legend.classList.add('bhl-native-step-label');
    legend.prepend(marker);
  }

  /**
   * Physically moves Length and System to bracket <variant-picker> (Length
   * immediately before it, System — and Meta right after System — immediately
   * after it), so Tab order and screen-reader reading order follow the same
   * 01/02/03/04 sequence shown on screen instead of the original
   * server-rendered markup order (which put Length/System/Meta as a block
   * *before* the native Track Color / Light Temperature fields).
   *
   * This intentionally stops short of a full physical interleave (Length,
   * Track Color, System, Light Temperature). An earlier version of this fix
   * also swapped the two native fieldsets into that order, but testing
   * surfaced a real regression: <variant-picker>'s morph() (assets/morph.js)
   * reconciles its own subtree against fresh server markup on every variant
   * change using positional, unkeyed matching for same-tag siblings (no
   * data-key/id to match by) — so once the fieldsets' DOM order no longer
   * matches the server's fixed render order, the morph can attribute-copy
   * and content-overwrite the wrong live fieldset, and a Light Temperature
   * selection could silently lose its checked state after the next
   * fetch/morph. Track Color and Light Temperature are therefore left
   * exactly where Shopify renders them, inside <variant-picker>, untouched —
   * moving them out would also stop their `change` events bubbling to
   * variant-picker's own listener (assets/variant-picker.js), breaking its
   * fetch/update logic. The residual mismatch (Light Temperature reads
   * before Track Color, and System reads after both instead of between
   * them) is the accepted tradeoff for not touching Shopify's own
   * morph-managed markup.
   *
   * Re-run after every native-option decoration pass (initial load, the
   * scheduled retries, and the shopify:product:select handler below) since a
   * `morphElementSelector: 'main'` re-render (combined listings) could in
   * principle touch these outer siblings too.
   */
  function reorderForAccessibility() {
    const variantPickerEl = document.querySelector('variant-picker');
    if (!variantPickerEl) return;

    const splitVoltage = ensureSplitVoltageSelector();

    if (lengthStep && variantPickerEl.previousElementSibling !== lengthStep) {
      variantPickerEl.before(lengthStep);
    }

    if (splitVoltage && lengthStep && lengthStep.previousElementSibling !== splitVoltage) {
      lengthStep.before(splitVoltage);
    }

    if (systemStep && hasSystemStep && variantPickerEl.nextElementSibling !== systemStep) {
      variantPickerEl.after(systemStep);
    }

    const lineTemperature = document.querySelector('[data-bhl-line-temperature]');
    if (lineTemperature) {
      const temperatureAnchor = hasSystemStep && systemStep ? systemStep : variantPickerEl;
      if (temperatureAnchor.nextElementSibling !== lineTemperature) {
        temperatureAnchor.after(lineTemperature);
      }
    }

    const metaAnchor = (hasSystemStep && systemStep) || lineTemperature || variantPickerEl;
    if (metaEl && metaAnchor.nextElementSibling !== metaEl) {
      metaAnchor.after(metaEl);
    }
  }

  function decorateNativeOptions() {
    const combinedFields = combinedConfigurationFields();
    const combinedFieldset = combinedFields[0]?.closest('fieldset');
    if (combinedFieldset) {
      combinedFieldset.hidden = true;
      combinedFieldset.style.setProperty('display', 'none', 'important');
      combinedFieldset.setAttribute('aria-hidden', 'true');
    }

    ensureSplitVoltageSelector();
    ensureLineItemTemperature();
    syncSplitControlsFromNative();

    const lightField = document.querySelector('input[type="radio"][name^="Light Temperature-"]');
    const trackFields = [...document.querySelectorAll('input[type="radio"][name^="Track Color-"]')];
    const voltageFields = [...document.querySelectorAll('input[type="radio"][name^="Voltage-"]')];
    const lightFieldset = lightField?.closest('fieldset');
    const trackFieldset = trackFields[0]?.closest('fieldset');
    const voltageFieldset = voltageFields[0]?.closest('fieldset');
    const hasVoltageStep = Boolean(voltageFieldset);

    reorderForAccessibility();

    if (lengthStepNumber) lengthStepNumber.textContent = hasVoltageStep ? '02' : '01';
    addStepNumber(voltageFieldset, '01');
    addStepNumber(lightFieldset, '04');
    addStepNumber(trackFieldset, hasVoltageStep ? '03' : '02');

    if (voltageFieldset) {
      const checkedVoltage = voltageFields.find((field) => field.checked)?.value || '';
      const selectedLength = normalizeLength(currentConfiguration());
      const legend = voltageFieldset.querySelector('legend');
      let valueEl = legend?.querySelector('.bhl-legend-value');
      if (legend && !valueEl) {
        valueEl = document.createElement('span');
        valueEl.className = 'bhl-legend-value';
        legend.appendChild(valueEl);
      }
      if (valueEl && valueEl.textContent !== checkedVoltage) valueEl.textContent = checkedVoltage;

      voltageFields.forEach((field) => {
        const label = field.closest('label');
        if (!label) return;
        let copy = label.querySelector('.bhl-voltage-option-copy');
        if (!copy) {
          copy = document.createElement('small');
          copy.className = 'bhl-voltage-option-copy';
          label.appendChild(copy);
        }

        const unavailable = selectedLength === '400FT' && /12V/i.test(field.value);
        field.disabled = unavailable;
        label.classList.toggle('bhl-voltage-option--unavailable', unavailable);
        label.setAttribute('aria-disabled', String(unavailable));
        copy.textContent = unavailable
          ? 'Not available at 400FT. Choose 24V.'
          : /24V/i.test(field.value)
            ? 'Ideal for longer runs; required at 400FT.'
            : 'Reliable choice for systems up to 350FT.';
      });
    }

    if (trackFieldset) {
      let selectedLabel = trackFieldset.querySelector('[data-bhl-selected-track-color]');
      if (!selectedLabel) {
        selectedLabel = document.createElement('p');
        selectedLabel.className = 'bhl-selected-track-color';
        selectedLabel.dataset.bhlSelectedTrackColor = '';
        const legend = trackFieldset.querySelector('legend');
        legend?.insertAdjacentElement('afterend', selectedLabel);
      }

      const checked = trackFields.find((field) => field.checked);
      const selectedValue = checked?.value || 'Choose a color';
      if (selectedLabel.dataset.selectedValue !== selectedValue) {
        selectedLabel.innerHTML = `<span>Selected:</span> ${selectedValue}`;
        selectedLabel.dataset.selectedValue = selectedValue;
      }

      renderTrackColorHelp(selectedValue);

      const legend = trackFieldset.querySelector('legend');
      if (legend) {
        let valueEl = legend.querySelector('.bhl-legend-value');
        if (!valueEl) {
          valueEl = document.createElement('span');
          valueEl.className = 'bhl-legend-value';
          legend.appendChild(valueEl);
        }
        if (valueEl.textContent !== selectedValue) valueEl.textContent = selectedValue;
      }
    }

    positionCustomColorHelp();
  }

  function positionCustomColorHelp() {
    if (!customColorHelp) return;
    const trackField = document.querySelector('input[type="radio"][name^="Track Color-"]');
    const fieldset = trackField?.closest('fieldset');
    if (fieldset && fieldset.nextElementSibling !== customColorHelp) {
      fieldset.insertAdjacentElement('afterend', customColorHelp);
    }
  }

  function renderTrackColorHelp(selectedValue) {
    if (!customColorHelp) return;

    const normalized = String(selectedValue || '').trim().toLowerCase();
    let copy = '';
    let isCustom = false;

    if (normalized === 'brown') {
      copy = '<strong>Brown:</strong> <strong>HEX</strong> #5A3826 &middot; <strong>RGB</strong> 90, 56, 38 &middot; RAL 8011';
    } else if (normalized === 'oyster' || normalized === 'oysterwhite' || normalized === 'oyster white') {
      copy = '<strong>Oyster:</strong> <strong>HEX</strong> #E3D9C6 &middot; <strong>RGB</strong> 227, 217, 198 &middot; RAL 1013';
    } else if (/custom/.test(normalized)) {
      isCustom = true;
      copy = `
        <span class="bhl-track-color-help__heading">
          <span class="bhl-track-color-help__badge">Made to order</span>
          <strong>How a custom track color works</strong>
        </span>
        <span class="bhl-track-color-help__steps">
          <span><i>1</i><strong>Purchase first.</strong><small>The palette is sent only after your order is placed.</small></span>
          <span><i>2</i><strong>Match and confirm.</strong><small>Select the finish that best matches your exterior.</small></span>
          <span><i>3</i><strong>We manufacture.</strong><small>Your custom tracks are produced after confirmation.</small></span>
        </span>
        <span class="bhl-track-color-help__timing"><strong>Timing:</strong> Production can take up to 2 weeks after color confirmation.</span>
      `;
    }

    customColorHelp.hidden = !copy;
    customColorHelp.classList.toggle('bhl-custom-color-help--custom', isCustom);
    if (copy && customColorHelp.dataset.selectedValue !== normalized) {
      customColorHelp.innerHTML = copy;
      customColorHelp.dataset.selectedValue = normalized;
    }
  }

  function positionPurchaseAssurance() {
    if (!assurance) return;
    const addToCart = document.querySelector('[data-testid="standalone-add-to-cart"]');
    const productForm = addToCart?.closest('product-form-component');
    if (productForm) productForm.insertAdjacentElement('afterend', assurance);
  }

  mountAndHideNativeConfiguration();
  render();
  decorateNativeOptions();
  positionPurchaseAssurance();
  positionIncludes();
  syncSku();
  syncLineItemTemperature(false);

  document.addEventListener('change', () => window.setTimeout(syncSku, 80));

  // Horizon's <variant-picker> (assets/variant-picker.js) dispatches
  // `shopify:product:select` (StandardEvents.productSelect from
  // @shopify/events, loaded via the importmap in snippets/scripts.liquid)
  // on every variant change, bubbling to document — both from native
  // option clicks and from our own selectConfiguration() radio/select
  // dispatches — and resolves event.promise once the section fetch + DOM
  // morph it triggers has finished. That single, precise signal replaces:
  //   - the previous 300ms setInterval poll of input[name="id"] that used
  //     to detect variant changes to re-run syncSku(), and
  //   - a pickerObserver MutationObserver that used to re-run
  //     decorateNativeOptions() on any mutation anywhere in <variant-picker>.
  document.addEventListener('shopify:product:select', (event) => {
    event.promise
      ?.then(() => {
        decorateNativeOptions();
        syncSku();
        syncLineItemTemperature(false);

        if (pendingLength) {
          const nextLength = pendingLength;
          pendingLength = '';
          selectConfiguration(nextLength);
          window.setTimeout(() => render(nextLength), 0);
        }
      })
      .catch(() => {});
  });

  scheduleNativeDecoration();
  window.setTimeout(positionPurchaseAssurance, 300);
  (function retryIncludes(n) {
    const placed = positionIncludes();
    if (!placed && n < 20) window.setTimeout(() => retryIncludes(n + 1), 250);
  })(0);
  if (mobileIncludesQuery.addEventListener) {
    mobileIncludesQuery.addEventListener('change', positionIncludes);
  } else {
    mobileIncludesQuery.addListener(positionIncludes);
  }
  if (document.readyState !== 'complete') {
    window.addEventListener('load', positionIncludes, { once: true });
  }
  window.setTimeout(positionPurchaseAssurance, 1200);
  window.setTimeout(syncLineItemTemperature, 300);
  window.setTimeout(syncLineItemTemperature, 1200);
})();
